import { render, staticRenderFns } from "./chooseBgm.vue?vue&type=template&id=0d760681&scoped=true&"
import script from "./chooseBgm.ts?vue&type=script&lang=js&"
export * from "./chooseBgm.ts?vue&type=script&lang=js&"
import style0 from "./chooseBgm.less?vue&type=style&index=0&id=0d760681&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d760681",
  null
  
)

export default component.exports